import React, { FC } from "react";
import Box from "@mui/material/Box";
import GuideCard from "./GuideCard";
import { INSTALLATION_GUIDES } from "../../data/installation-guides";

export interface GuideGridProps {
  /** Guide key to outline, from `/guides?product=<key>`. */
  highlightKey?: string | null;
}

/**
 * CSS grid with `auto-fit` rather than fixed 12-column spans: the catalogue is
 * five entries today and grows as products ship, and a hardcoded span would
 * strand the last card on its own row (which four-per-row did with five cards).
 */
const GuideGrid: FC<GuideGridProps> = ({ highlightKey }) => (
  <Box
    sx={{
      display: "grid",
      gap: 2.5,
      gridTemplateColumns: {
        mobile: "1fr",
        tablet: "repeat(auto-fit, minmax(220px, 1fr))",
      },
      alignItems: "stretch",
    }}
  >
    {INSTALLATION_GUIDES.map((guide) => (
      <GuideCard
        guide={guide}
        highlighted={guide.key === highlightKey}
        key={guide.key}
      />
    ))}
  </Box>
);

export default GuideGrid;
